//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CardPropertyIcon from './CardPropertyIcon.vue'
import { cardPropertyMixin } from './CardPropertyMixin.js'

export default {
  name: 'CardPropertyNumber',
  components: {
    CardPropertyIcon
  },
  mixins: [cardPropertyMixin],
  props: {
    tabProp: {
      type: Object,
      default: null
    },
    object: {
      type: Object,
      default: null
    }
  },
  computed: {
    componentProps: function () {
      return (this.tabProp && this.tabProp.componentProps) || {}
    },
    rule: function () {
      const value = this.object[this.tabProp.key]
      if (this.tabProp.additionalValidateFn || this.tabProp.validateFn) {
        let validate = true
        if (this.tabProp.additionalValidateFn) {
          validate = validate && this.tabProp.additionalValidateFn(value)
        }
        if (this.tabProp.validateFn) {
          validate = validate && this.tabProp.validateFn(value)
        }
        return validate
      }

      // Дефолтная валидация компонента
      if (value == null || value === '') {
        return !this.tabProp.required
      }

      const min = this.tabProp.mininteger
      const max = this.tabProp.maxinteger

      if (this.tabProp.type === 'integer') {
        if (min != null && max != null) {
          return (value >= min && value <= max && Number.isInteger(value)) || 'Введите целое число от ' + min + ' до ' + max
        } else {
          return value ? (Number.isInteger(value) || 'Введите целое число') : true
        }
      } else {
        if (min != null && max != null) {
          return (value && value >= min && value <= max) || 'Введите число от ' + min + ' до ' + max
        } else {
          return true
        }
      }
    }
  },
  watch: {
    object: {
      handler: function () {
        if (this.$refs.field) {
          this.$nextTick(() => this.$refs.field.validate())
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    onInput: function (value) {
      if (!value) {
        this.object[this.tabProp.key] = null
      }

      if (this.tabProp.onPropertyInput instanceof Function) {
        this.tabProp.onPropertyInput(value, this.object)
      }
    }
  }
}
